<!-- Fullscreen Loader -->
@if (type === 'fullscreen') {
<div class="fixed inset-0 bg-white bg-opacity-90 z-50 flex items-center justify-center" style="backdrop-filter: blur(2px);">
  <div class="flex flex-col items-center gap-3">
    <p-progress-spinner 
      [ariaLabel]="ariaLabel"
      [style]="spinnerStyle">
    </p-progress-spinner>
    
    @if (message) {
      <p class="text-gray-600 font-medium" [class]="messageTextClass">{{ message }}</p>
    }
  </div>
</div>
}

<!-- Card Loader -->
@if (type === 'card') {
<div class="p-8 bg-white rounded-xl shadow-sm border border-gray-100 flex items-center justify-center">
  <div class="flex flex-col items-center gap-3">
    <p-progress-spinner 
      [ariaLabel]="ariaLabel"
      [style]="spinnerStyle">
    </p-progress-spinner>
    
    @if (message) {
      <p class="text-gray-600 font-medium" [class]="messageTextClass">{{ message }}</p>
    }
  </div>
</div>
}

<!-- Inline Loader -->
@if (type === 'inline') {
<div class="p-8 flex items-center justify-center">
  <div class="flex flex-col items-center gap-3">
    <p-progress-spinner 
      [ariaLabel]="ariaLabel"
      [style]="spinnerStyle">
    </p-progress-spinner>
    
    @if (message) {
      <p class="text-gray-600 font-medium" [class]="messageTextClass">{{ message }}</p>
    }
  </div>
</div>
}
